import {
  Autocomplete,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Box, Grid } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";

const PairAddRecordsFilter = () => {
  const WebsiteList = [
    { label: "websitenameexample" },
    { label: "websitenameexample.com" },
    { label: "website" },
    { label: "websitename" },
  ];

  return (
    <>
    <Box sx={{padding:'20px 16px 0px 16px !important'}}>
      <Grid container rowSpacing={6} columnSpacing={3} alignItems={"center"}>
        <Grid size={3}>
          <Autocomplete
            sx={{ width: "100%" }}
            options={WebsiteList}
            renderInput={(params) => (
              <TextField
                {...params}
                label="FME"
                value={""}
                // sx={{ width: "300px" }}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ marginLeft: "12px" }} />
                    </InputAdornment>
                  ),
                }}
                color="secondary"
              />
            )}
            size="small"
          />
        </Grid>
        <Grid size={7}>
          <Typography>Filter will appear hear</Typography>
        </Grid>
      </Grid>
      </Box>
    </>
  );
};

export default PairAddRecordsFilter;
